var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnCollapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 25.5C17 26.163 16.7366 26.7989 16.2678 27.2678C15.7989 27.7366 15.163 28 14.5 28C13.837 28 13.2011 27.7366 12.7322 27.2678C12.2634 26.7989 12 26.163 12 25.5V18H4.5C3.83696 18 3.20107 17.7366 2.73223 17.2678C2.26339 16.7989 2 16.163 2 15.5C2 14.837 2.26339 14.2011 2.73223 13.7322C3.20107 13.2634 3.83696 13 4.5 13H12V5.5C12 4.83696 12.2634 4.20107 12.7322 3.73223C13.2011 3.26339 13.837 3 14.5 3C15.163 3 15.7989 3.26339 16.2678 3.73223C16.7366 4.20107 17 4.83696 17 5.5V13H24.5C25.163 13 25.7989 13.2634 26.2678 13.7322C26.7366 14.2011 27 14.837 27 15.5C27 16.163 26.7366 16.7989 26.2678 17.2678C25.7989 17.7366 25.163 18 24.5 18H17V25.5Z",
    fill: "#2D3748"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnCollapse);
export default __webpack_public_path__ + "static/media/UnCollapse.68259b998066a06c78480820ae3d19f4.svg";
export { ForwardRef as ReactComponent };